const month = {
	state:{
		supportPlate: [],
		breath: '',
		hasLock: ''
	},
	actions:{
		
	},
	mutations:{
		setSupportPlate(state, payload) {
			state.supportPlate = [];
			for (var i = 0; i < payload.length; i++) {
				state.supportPlate.push(payload[i]);
			}
		},
		getBreath(state, payload) {
			state.breath = payload;
		},
		getHasLock(state, payload) {
			state.hasLock = payload;
		},
	},
	getters: {
	}
};

export default month;